import { render, staticRenderFns } from "./modifierInformation.vue?vue&type=template&id=1a296067&scoped=true&"
import script from "./modifierInformation.vue?vue&type=script&lang=js&"
export * from "./modifierInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a296067",
  null
  
)

export default component.exports